import "../../styles/global-ui/gui-custom-select.scss";

export function GuiCustomSelect(props) {
  const { data, innerRef, innerProps, selectProps } = props;

  return (
    <div ref={innerRef} {...innerProps} className="custom-option">
      <span>{data?.label}</span>
      {data?.isCustomContactType && (
        <span>
          <i
            className="fa fa-pencil custom-option-edit"
            title="Edit"
            onClick={(e) => {
              e.stopPropagation();
              selectProps.onEditCustomType?.(data);
            }}
          ></i>
          <i
            className="fa fa-trash custom-option-delete"
            title="Delete"
            onClick={(e) => {
              e.stopPropagation();
              selectProps.onDeleteCustomType?.(data);
            }}
          ></i>
        </span>
      )}
    </div>
  );
}
